<template>
  <div>
    <div class="info-okvir" :style="`background-color: ${backgroundColor}; border: ${border}`">
      <i :class="icon" :style="`font-size: ${iconSize}; color: ${iconColor};`"></i>
      <div class="postavitev-info-tekst">
        <p :style="`color: ${textColor} !important; font-size: ${fontSize};`" class="mb-0">
          <slot></slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoKomponentaGlobalna',
  props: {
    icon: {
      type: String,
      default: 'fa fa-info-circle'
    },
    iconSize: {
      type: String,
      default: '40px'
    },
    iconColor: {
      type: String,
      default: '#409eff'
    },
    textColor: {
      type: String,
      default: '#409eff'
    },
    backgroundColor: {
      type: String,
      default: '#e6f1fc'
    },
    border: {
      type: String,
      default: 'solid 1px #409eff'
    },
    fontSize: {
      type: String,
      default: '14px'
    }
  }
}
</script>

<style scoped>
.modra-barva-info a {
  color: unset;
}

.info-okvir {
  width: 100%;
  display: flex;
}

i {
  width: auto;
  margin-right: 20px;
}

@media only screen and (min-width: 1450px) {
  .info-okvir {
    max-width: 900px;
  }
}

@media only screen and (max-width: 730px) {
  .info-okvir {
    padding: 16px;
  }
  i {
    margin-right: 16px;
  }
}
@media only screen and (max-width: 550px) {
  i {
    font-size: 26px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/InfoKomponentaGlobalna.vue